import { Component, OnInit } from '@angular/core';
import { WalletService } from '../services/wallet.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-matmbuy',
  templateUrl: './matmbuy.component.html',
  styleUrls: ['./matmbuy.component.scss']
})
export class MatmbuyComponent implements OnInit {
  getDevice:any=[]
  selectedDevice: any;
  constructor(private service :WalletService,private toast:ToastrService,private router:Router,private loader:NgxUiLoaderService) { }

  ngOnInit(): void {
    this.getMATMDevice()
  }
getMATMDevice(){
  this.service.getMAtmDevice().subscribe((res:any)=>{
    if(res.status_code == 1){
      this.getDevice = res.object;
    }else {
      this.getDevice = "";
    }
  },err=>{

  })
}
submit(){
  if (this.selectedDevice === undefined) {
    // Handle validation error, show a message, or prevent submission
    this.toast.error('Please Select a Device before proceeding to buy')
    // this.router.navigate(['/dashboard']); // Replace '/next-page' with your actual route

  } else {
    // Proceed with the submission logic
    console.log('Selected Device:', this.selectedDevice);
    this.loader.start()
    // Add your logic to complete the purchase
      this.service.buyProduct(this.selectedDevice).subscribe((res:any)=>{
    if(res.status_code == 1){
      this.loader.stop()

      this.toast.success(res.message)
      this.router.navigate(['/dashboard']); // Replace '/next-page' with your actual route

    }else {
    this.loader.stop()
      this.toast.error(res.error.message)
      // this.router.navigate(['/dashboard']); // Replace '/next-page' with your actual route


    }
  },err=>{
    this.loader.stop()


  })
  }
}
  // this.service.buyProduct(this.selectedDevice).subscribe((res:any)=>{
  //   if(res.status_code == 1){
  //   }else {
  //   }
  // },err=>{

  // })

}
